<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 55px; top: 55px">
      <p>Completa cada enunciado eligiendo una de estas palabras:</p>
    </span>

    <p
      class="textBase basicItem01 tagDefault"
      style="width: 170px; left: 50px; top: 130px"
    >
      PARA
    </p>
    <p
      class="textBase basicItem02 tagDefault alt"
      style="width: 180px; left: 280px; top: 140px"
    >
      CUANDO
    </p>
    <p
      class="textBase basicItem01 tagDefault"
      style="width: 130px; left: 530px; top: 130px"
    >
      COMO
    </p>

    <p
      class="textBase"
      style="
        top: 250px;
        left: 50px;
        font-size: 32px;
        position: absolute;
        line-height: 45px;
      "
    >
      EN ALGUNOS PAÍSES SE CONSUMEN<br />GRILLOS
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
        style="width: 140px"
      />
      ALIMENTO.
    </p>

    <p
      class="textBase"
      style="
        top: 400px;
        left: 50px;
        font-size: 32px;
        position: absolute;
        line-height: 45px;
      "
    >
      LOS GRILLOS CANTAN
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
        style="width: 170px"
      />
      ATRAER A LAS HEMBRAS.
    </p>

    <p
      class="textBase"
      style="
        top: 500px;
        left: 50px;
        font-size: 32px;
        position: absolute;
        line-height: 45px;
      "
    >
      LOS GRILLOS PRODUCEN SU "CANTO"
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="3"
        style="width: 190px"
      />
      FROTAN LAS ALAS CONTRA LAS PATAS DE ATRÁS.
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 117c.mp4",
        "vio/Video 117b.mp4",
        "vio/Video 118.mp4",
        "vio/Video 119.mp4",
        "vio/Video 120.mp4",
      ],
    };
  },
};
</script>